import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { modalBackdropColor, white, appTextColor } from '../../../styles/colors';

import { launchpadActions, launchpadSelectors } from '../reducer/launchpad-reducer';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion/dist/index';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { LinkButton } from '../../../styles/LinkButton';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const ModalBackdrop = styled.div(() => {
  let style = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    display: 'block',
    backgroundColor: modalBackdropColor,
    overflow: 'auto',
    zIndex: '1040'
  };
  return style;
});

const TriggerBox = styled.div((props) => {
  let style = {
    position: 'absolute',
    left: !props.isMobile ? 'calc(50% - 365px)' : '16px',
    right: !props.isMobile ? 'calc(50% - 365px)' : '16px',
    top: !props.isMobile ? 'calc(50% - 165px)' : '20%',
    padding: !props.isMobile ? '70px 70px 60px' : '50px 30px 40px',
    zIndex: '9999',
    backgroundColor: white,
    color: appTextColor,
    borderRadius: '4px',
    minHeight: '200px',
    width: !props.isMobile ? '730px' : 'auto',
    textAlign: 'center',
    height: !props.isMobile ? '330px' : 'auto'
  };

  return style;
});

const TriggerTextContainer = styled.div(() => {
  let style = {
    marginBottom: 20
  };
  return style;
});

const TriggerHeading2 = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '32px' : '24px',
    width: '80%',
    margin: 'auto'
  };
  return style;
});

const TriggerMessage = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '18px' : '16px',
    marginTop: 12,
    lineHeight: '24px',
    paddingRight: 20
  };
  return style;
});

const TriggerButtonsContainer = styled.div(() => {
  let style = {
    display: 'inline-block'
  };
  return style;
});

const TriggerButton = styled(LaunchpadButton)(() => {
  let style = {
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '16px',
    width: 'auto',
    textAlign: 'center',
    borderRadius: '4px',
    margin: '0 40px'
  };

  return style;
});

const DismissButton = styled(LinkButton)(() => {
  let style = {
    position: 'absolute',
    right: 25,
    color: appTextColor,
    fontSize: '13px',
    top: 25
  };
  return style;
});

//*********************************************
export class TestAlert extends PureComponent {
  componentWillMount = () => {};

  handleTriggerClick = () => {
    window.location = this.props.optionalTriggerRecommendation;
  };

  handleDismissClick = () => {
    this.props.clearOptionalTrigger();
  };

  /*
    render!
   */
  render = () => {
    const isMobile = isMobileDetected;

    let proficiencyTriggerHeading2 = this.props.lionTranslateString('proficiency_trigger_heading2');
    let proficiencyTriggerMessage = this.props.lionTranslateString('proficiency_trigger_message');
    if (this.props.optionalTriggerIsAdaptiveBeta) {
      proficiencyTriggerHeading2 = this.props.lionTranslateString('proficiency_adaptive_heading');
      proficiencyTriggerMessage = this.props.lionTranslateString('proficiency_adaptive_description');
    }

    return (
      <div>
        <ModalBackdrop />
        <TriggerBox isMobile={isMobile}>
          <DismissButton data-qa="dismissOptionalTrigger" onClick={this.handleDismissClick}>
            &#x2715;
          </DismissButton>
          <TriggerTextContainer>
            <TriggerHeading2 isMobile={isMobile}>{proficiencyTriggerHeading2}</TriggerHeading2>
            <TriggerMessage isMobile={isMobile}>{proficiencyTriggerMessage}</TriggerMessage>
          </TriggerTextContainer>
          <TriggerButtonsContainer>
            <TriggerButton data-qa="launchOptionalTrigger" onClick={this.handleTriggerClick}>
              <LionTranslate lionkey="proficiency_trigger_take_test_button" />
            </TriggerButton>
          </TriggerButtonsContainer>
        </TriggerBox>
      </div>
    );
  };
}

TestAlert.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  daysUntilTrigger: launchpadSelectors.daysUntilTrigger(state),
  optionalTriggerIsAdaptiveBeta: launchpadSelectors.optionalTriggerIsAdaptiveBeta(state),
  optionalTriggerRecommendation: launchpadSelectors.optionalTriggerRecommendation(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = { clearOptionalTrigger: launchpadActions.clearOptionalTrigger };
export const TestAlertContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(TestAlert));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/TestAlert.jsx